"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnUpdateSportEvent$ = exports.splitStreamsByBatching = exports.applyBufferToStream = exports.groupSportEventMessagesByOrigin = exports.handleEndedMatch = exports.handleDisabledMatch = exports.createSubscriptionMiddleware = void 0;
require("rxjs/add/operator/bufferTime");
require("rxjs/add/operator/do");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/merge");
require("rxjs/add/operator/partition");
var entities_1 = __importDefault(require("../entities"));
var types_1 = require("../types");
var utils_1 = require("../utils");
var actions_1 = require("./actions");
var constants_1 = require("./constants");
var normalize = entities_1.default.utils.normalize, _a = entities_1.default.actions, deleteMatchId = _a.deleteMatchId, endMatch = _a.endMatch;
function createSubscriptionMiddleware(subscriptionManager) {
    return function (store) {
        subscriptionManager.messages$
            .filter(filterOutEmptyMessages('onUpdateBet'))
            .map(function (message) {
            return message.body.data.onUpdateBet;
        })
            .subscribe(function (convertedBet) {
            var entities = normalize({
                bets: [convertedBet],
            }).entities;
            store.dispatch(actions_1.updateBet(entities));
        });
        var sportEvent$ = getOnUpdateSportEvent$(subscriptionManager);
        var enhancedSportEvent$ = handleSportEventEdgeCases(sportEvent$, store);
        var _a = splitStreamsByBatching(enhancedSportEvent$), batchOnUpdateSportEvent$ = _a[0], singleOnUpdateSportEvent$ = _a[1];
        applyBufferToStream(batchOnUpdateSportEvent$)
            .merge(singleOnUpdateSportEvent$.map(function (message) { return [message]; }))
            .map(groupSportEventMessagesByOrigin)
            .subscribe(function (groupedMatches) {
            Object.keys(groupedMatches).forEach(function (origin) {
                var groupByOrigin = groupedMatches[origin];
                if (!groupByOrigin)
                    return;
                var matches = groupByOrigin.matches, subOpts = groupByOrigin.subOpts;
                var entities = normalize({
                    matches: matches,
                }).entities;
                store.dispatch(actions_1.updateMatch(entities, origin, !!subOpts.variables.isTopMarkets));
            });
        });
        return function (next) { return function (action) {
            switch (action.type) {
                case constants_1.SUBSCRIBE_TO_UPDATES:
                    subscriptionManager.addSubscription(action.payload);
                    break;
                case constants_1.UNSUBSCRIBE_TO_UPDATES: {
                    subscriptionManager.removeSubscription(action.payload);
                    break;
                }
                default:
                    return next(action);
            }
        }; };
    };
}
exports.createSubscriptionMiddleware = createSubscriptionMiddleware;
function handleDisabledMatch(store, _a) {
    var disabled = _a.disabled, matchId = _a.id;
    if (!disabled)
        return;
    store.dispatch(deleteMatchId({
        matchId: matchId,
    }));
}
exports.handleDisabledMatch = handleDisabledMatch;
function handleEndedMatch(store, nextMatch) {
    var currentMatch = store.getState().entities.matches.get(nextMatch.id);
    if (currentMatch && checkMatchHasEnded(currentMatch.status))
        return;
    if (checkMatchHasEnded(nextMatch.fixture.status)) {
        store.dispatch(endMatch({
            matchId: nextMatch.id,
        }));
        if (utils_1.checkOnRoute(types_1.App.Routes.RESULTS_LIST)) {
            store.dispatch(actions_1.searchMatches());
        }
    }
}
exports.handleEndedMatch = handleEndedMatch;
function groupSportEventMessagesByOrigin(messageList) {
    return messageList.reduce(function (acc, _a) {
        var body = _a.body, opts = _a.opts;
        var origin = opts.origin, subOpts = opts.subOpts;
        var match = body.data.onUpdateSportEvent;
        if (acc[origin]) {
            acc[origin].matches.push(match);
            acc[origin].subOpts = subOpts;
        }
        else {
            acc[origin] = {
                matches: [match],
                subOpts: subOpts,
            };
        }
        return acc;
    }, {});
}
exports.groupSportEventMessagesByOrigin = groupSportEventMessagesByOrigin;
function applyBufferToStream(stream$, bufferTimeMS) {
    if (bufferTimeMS === void 0) { bufferTimeMS = 1000; }
    return stream$.bufferTime(bufferTimeMS).filter(function (messageList) {
        return !!messageList.length;
    });
}
exports.applyBufferToStream = applyBufferToStream;
function splitStreamsByBatching(stream) {
    return stream.partition(function (_a) {
        var opts = _a.opts;
        return opts.batch;
    });
}
exports.splitStreamsByBatching = splitStreamsByBatching;
function getOnUpdateSportEvent$(subscriptionManager) {
    return subscriptionManager.messages$.filter(filterOutEmptyMessages('onUpdateSportEvent'));
}
exports.getOnUpdateSportEvent$ = getOnUpdateSportEvent$;
function checkMatchHasEnded(status) {
    return ![
        types_1.GQL.SportEventStatus.LIVE,
        types_1.GQL.SportEventStatus.SUSPENDED,
        types_1.GQL.SportEventStatus.NOT_STARTED,
    ].includes(status);
}
function handleSportEventEdgeCases(stream, store) {
    return stream.do(function (message) {
        var match = message.body.data.onUpdateSportEvent;
        handleDisabledMatch(store, match);
        handleEndedMatch(store, match);
    });
}
function filterOutEmptyMessages(subscriptionClientMethodName) {
    return function (message) {
        return message.opts.subOpts.method === subscriptionClientMethodName &&
            !!message.body.data;
    };
}
//# sourceMappingURL=middleware.js.map